import React, { useState, useEffect, useRef, useContext } from "react";

// Librerias de componentes
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";

import { obtenerSubCategorias } from "../../../../Base/API/Global/SubCategorias/SubCategoriasRequests"; 
import Card from "../../../../Base/Components/Card/Card";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext"; 
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";

import SubCategoriasCrudModal from "./ModalSubCategorias/SubCategoriasCrudModal";
import { Checkbox } from "primereact/checkbox";

// import './categoriaStyle.scss';

export const SubCategoriasScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [subCategoria, setSubCategoria] = useState("");
  const [subCategoriaEdit, setSubCategoriaEdit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);

  const getInfo = async () => {
    setLoading(true);
    const r = await obtenerSubCategorias();
    setSubCategoria(r?.filter(i => i?.IdStatus !== 7));
    setLoading(false);
  };


  const colums = [
    {
      field: "IdSubCategoria",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "NombreSubcategoria",
      header: "SubCategorías",
      headerEn: "SubCategories",
      flex: 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "NombreCategoria",
      header: "Categorías",
      headerEn: "Categories",
      flex: 1,
    },
    { field: "Comentario", header: "Comentario", headerEn: "Comment", flex: 1 },
    {
      field: "AplicaLiquidacion",
      header: "Aplica Liquidación",
      headerEn: "Apply liquidation",
      Format: "Template",
      className: 'medium',
      align: "center",
      body: (rowData) => rowData?.IdSubCategoria && (<Checkbox style={{ marginBottom: 5 }} checked={rowData.AplicaLiquidacion} disabled/>),
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "IdCategoria",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          className: "custom-tooltip",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: subCategoria,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "categoria", config.language));
    getInfo();
  }, []);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast}></Toast>
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "subcategoria", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />

      {showDialog && (
        <SubCategoriasCrudModal
          toastRef={toast}
          subcategoriasDialog={showDialog}
          subcategoria={selected}
          setSubcategoriasDialog={setShowDialog}
          getSubCat={getInfo}
          modo={selected ? "Editar" : "Crear"}
        />
      )}
    </div>
  );
};

export default SubCategoriasScreen;
